/*
 * Remove multiple instances question marks (?) in query param
 *
 * @param {string} queryParam - the query parameter
 * @returns {string}
 */
export default function cleanQueryParams(queryParam = ''): string {
  return queryParam.replace(/\?/g, '&').replace('&', '?');
}
